<div class="body">
    <app-widget-view-standalone [widgets]="widgets" (addWidgetAnchor)="widgetAdded($event)" (deleteWidgetAnchor)="widgetDeleted($event)"></app-widget-view-standalone>
</div>